import { Form, FormItem, Input } from 'formik-antd';
import { Button, Card, Typography } from 'antd';
import { Formik } from 'formik';
import * as React from 'react';
import styled from 'styled-components';
import { FormikOnSubmit } from 'lib/formik.utils';
import { requiredEmailValidationSchema } from 'common/config/validationSchema';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { FormattedMessage } from 'react-intl';

const { Title } = Typography;

export interface ForgetPasswordFormModel {
  email: string;
}

export interface ForgetPasswordFormProps {
  loading: boolean;
  onSubmit: FormikOnSubmit<ForgetPasswordFormModel>;
}

const StyledCard = styled(Card)`
  width: 400px;
`;

export const ForgetPasswordForm: React.FC<ForgetPasswordFormProps> = ({
  onSubmit,
  loading,
}) => {
  const intlMessage = useFormatMessage();

  return (
    <Formik
      initialValues={{
        email: '',
      }}
      onSubmit={onSubmit}
      validationSchema={requiredEmailValidationSchema(intlMessage)}
    >
      <Form>
        <Title style={{ textAlign: 'center' }}>
          {intlMessage({ id: 'authentication.resetPasswordHeader' })}
        </Title>
        <StyledCard>
          <FormattedMessage id="authentication.resetPasswordDescription" />
          <FormItem name="email">
            <Input
              style={{ marginTop: '30px' }}
              name="email"
              type="email"
              placeholder={intlMessage({ id: 'email' })}
            />
          </FormItem>
          <Button
            htmlType="submit"
            loading={loading}
            style={{ width: '100%', backgroundColor: 'rgb(57, 192, 254)' }}
            type="primary"
          >
            <FormattedMessage
              id="authentication.sendResetLink"
              tagName="span"
            />
          </Button>
        </StyledCard>
      </Form>
    </Formik>
  );
};
